/**
 * Generic Node Component - Blue colored node for generic processing nodes
 * Uses exported Figma asset for the icon
 */

import React from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import genericIcon from '../../assets/generic.png';
import './graphNodes.css';

interface GenericNodeData {
  label: string;
  description?: string;
  vulnerabilityCount?: number;
}

const GenericNode: React.FC<NodeProps<GenericNodeData>> = ({ data }) => {
  return (
    <div className="workflow-node workflow-node--generic">
      {/* LEFT: target="left", source="left-source" */}
      <Handle type="target" position={Position.Left} id="left" className="workflow-node__handle" />
      <Handle type="source" position={Position.Left} id="left-source" className="workflow-node__handle" />

      {/* RIGHT: source="right", target="right-target" */}
      <Handle type="source" position={Position.Right} id="right" className="workflow-node__handle" />
      <Handle type="target" position={Position.Right} id="right-target" className="workflow-node__handle" />

      {/* TOP: target="top", source="top-source" */}
      <Handle type="target" position={Position.Top} id="top" className="workflow-node__handle" />
      <Handle type="source" position={Position.Top} id="top-source" className="workflow-node__handle" />

      {/* BOTTOM: source="bottom", target="bottom-target" */}
      <Handle type="source" position={Position.Bottom} id="bottom" className="workflow-node__handle" />
      <Handle type="target" position={Position.Bottom} id="bottom-target" className="workflow-node__handle" />
      
      <div className="workflow-node__container">
        <img 
          src={genericIcon} 
          alt="Generic" 
          className="workflow-node__asset-icon"
        />
      </div>
      
      <div className="workflow-node__label">{data.label}</div>
    </div>
  );
};

export default GenericNode;
